import storeE from "../../../store";

export const validateStep3 = () => {
   return isGeographyValid() && isManagementValid()
}

export const isGeographyValid = () => {
    const newState = storeE.getState();
   // return !!newState.dimension.geography;
    return  !!newState.newSite.geography;
}

export const isManagementValid = () => {
    //const management = storeE.getState().dimension.management;
    const newState = storeE.getState();

    // const management = storeE.getState().newSite.management;
    return !!newState.newSite.management;
}


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/Validator.js